import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Hair_17 = ({ hairColours }) => {
  const primary = hairColours.base;
  const secondary = hairColours.shadow;
  return (
    <>
      <g>
        <g>
          <g>
            <path
              fill={primary}
              d="M489.4,272.9c18.9,49.7,36.4,163.2-7.7,203.7c-9.8,9-20.6,23.1-32.7,18c-7.5,18,2.5,32.7,21,33.5
				c-16.5,38.8,78.8,73.5,91.8,22.9c-42,27.1-19.5-58.3-10.4-75.5c18.7-35.4,41.6-54.9,40.3-99.7c-1.2-39.7-50.3-111.1-70.9-139.5
				L489.4,272.9z"
            />
            <path
              fill={primary}
              d="M339.8,188.2c-94.5-20.9-126,121.3-125.4,200.3c0.5,63.3,20.7,164.3,94.5,156.9c14.7-1.5,64.1-33.9,62.5,9.4
				c-0.2,0.9-1.4,5.8-2.2,6.5c36.7-0.2,31-48.8-5.4-59.5c9.5-3.1,9.9-9.4,15.1-20.5c-78.8,1.4-83.9-129.2-63.1-185.9
				c5.2-14.1,11.6-28.3,19.1-40.3L339.8,188.2z"
            />
            <path
              fill={primary}
              d="M310.9,211.5c15.1,66.9,97,87.8,153.4,75c26.4-6,43.9-21.2,57.8-46.2c-10.9-33.7-14.9-59.6-51.2-77.4
				c-31.4-15.3-85.4-15-115.6,1.9c-16.3,9.2-31.8,27.1-42.4,42.4L310.9,211.5z"
            />
          </g>
          <g>
            <path
              fill={secondary}
              d="M495.7,274.8c21.6,41,24.4,119.7,10.9,164.5c-4.9,16.5-27.5,79.1-57.1,59.3c12.7,25.4,24.3,18.5,41.5,15.7
				c22.6-3.7,36.4-24.9,48.8-45.6c26.1-43.5,23.7-86.3,8.9-132.5c-2.3-7.3-23.3-80-26.3-86.7L495.7,274.8z"
            />
            <path
              fill={secondary}
              d="M299.5,241.3c-44.3,36.3-65.9,97.2-69.1,156.3c-2.9,53.7,3.6,132.4,60.1,147.9c19.6,5.4,38.9-5.4,40.5-29.6
				c-7.4,28.2-38.7,12.9-49.8-2.6c-18.2-25.3-29.6-66.4-31-98.1c-2.2-49.6,14-131.9,46-168.7L299.5,241.3z"
            />
            <path
              fill={secondary}
              d="M336.6,209.3c23.8,51.2,102.7,73.8,147.4,44.8c5.7-3.7,10.9-8.2,15.4-13.3c-40.5,21.8-115.6,23.3-149.3-16.2
				c-0.6-0.8-1.2-1.6-1.8-2.4L336.6,209.3z"
            />
            <path
              fill={secondary}
              d="M280.2,348.2c-14.3,38.3-14.6,111.8,38.1,144C273.1,439.2,280.2,348.2,280.2,348.2z"
            />
            <path
              fill={secondary}
              d="M255.8,235.9c-13.7,10.8-20.6,33-23.7,49.6c2.9-5.1,6.8-9.6,9.9-14.3c-4.9,8.6-7.1,18.6-9.7,28.4
				c4.3-5,10.8-9.7,14.9-15c-6.6,10.4-9.1,23.1-8.1,35.7c6-11.8,15.4-21.3,24.9-29.9c-9,15.6-13,35.1-13.3,53.5
				c10.6-16.7,23.5-34.5,37.2-49.1c-1.4,7.3-1,16.1-2.8,23.2c2.4-5.4,6.4-11,8.8-15.8c-0.1,0-0.1,7.3,0.9,7.6
				c2.3-4.7,5.9-9.6,9.1-13.5c-0.4,5.9,0.6,12.1,0.1,18.1c9.6-19.6,19.5-40.9,25.1-61.7c-6.6,8.1-13.9,16.2-21.8,23.3
				c2.2-5,3.4-13.1,5.8-18.2c-6.3,4.8-16.5,8.9-22.7,14.9c1.6-4.9,1.7-11.4,3.6-16.5c-6.3,4.4-14.1,6.2-20.4,12.2
				c4.1-8.6,6.7-20.6,9.7-29.8c-12.2,6.5-21.3,19.6-34.1,25.8c2-5.6,2.4-12.4,5-18.2C247.7,250,255.8,235.9,255.8,235.9z"
            />
            <path
              fill={secondary}
              d="M351.9,263.5c13.7,10.7,28.1,16.5,45.1,16.8c0.2,0.2,0.4,0.1-0.8,0c0-0.1-3.6-1.9-4-2.6
				c12.8-0.7,27.1-1.2,39.5-6.7c-5.8-2.5-9.9-7.4-14.9-9.9c7,0.8,14.2-2.4,21.2-2c-3.3-2.5-6.3-8-10.5-10.6
				c10.6-2.3,21.2-4.6,31.9-6.2c-5.6-4.1-14.2-14.1-19.6-18.2c4.1-0.9,9.4-2.8,12.9-3.5c-1.8-1.9-6.1-4.2-7.1-6.7
				c2.2-2.7,7.7-1.9,9.2-4.1c0.6-0.3-1.7-3.2-1.3-4.1c6.1,0.3,12.2-2.6,18.9-2c-6.5-13.1-19.7-21.6-32.7-24
				c9.4-1.5,16.6-4.4,26.6-2.9c-6.6-5.7-11.8-11.7-21-14.4c0.7-1.9,4,0.8,4.4-1.4c-12.2-3.3-26.5-2.5-39.8-3.4c-0.4,0-0.4,0,0,0
				c9.4,1.3,17.7,7.3,24.5,13.4c0.1,0-0.1,2.6-0.1,2.6c-5.8,0.6-12.5,3.5-19.5,2.6c2.9,1.1,6.2,3,9.5,3.9c-0.2-0.7-5.3,1.7-5.8,1.2
				c2.2,2,4.8,3.9,6.8,6.6c-26.7,6.3-49.7,6.3-75.3,19.9c20.1,1.8,49.5,2.3,60.7,22.7c-6.6-1.1-13.9,0.7-20.4-0.6
				c4,2.8,8.2,9.3,12,12.2c-5.3-0.1-12.7,3.6-18.1,3.6c3.3,3,5.9,9.1,8.2,11.6c-12.7,3.4-26.5,3.2-37.8-4.2c6.7,4.1,12,10.7,18,15.9
				C367.3,269.8,351.9,263.5,351.9,263.5z"
            />
            <path
              fill={secondary}
              d="M521.2,249.8c41.3-4.8,68.5,61.6,60.4,99.8c-1.9,8.9-5.1,16.8-11.2,23.2c-0.3,0.1-0.3,0.1,0,0
				c29.4-39-11.6-107.7-47.5-118.9L521.2,249.8z"
            />
          </g>
          <g>
            <path
              fill={secondary}
              d="M334.7,254.2c18.4,31.6,55.7,53.1,90,53.1c-20.8-3.3-54.4-17-69.3-34L334.7,254.2z"
            />
            <g>
              <path
                fill={secondary}
                d="M244.3,255.7c-4,3.7-7.4,8.8-8.8,14.4c2.2-1.9,5.9-2.7,8.1-4.2c-0.7,2.2-0.9,5.1-1.7,7.3
					c1.1,1,3.2-0.8,4.2-0.3c-0.2,1.1-0.5,5.2-0.3,6.1c15-15.7,8.1,11.4,11,18.7c7.3-4.3,12.5-13.5,20.6-15.9
					c-1.6,3.1-2.1,7.6-3.8,10.8c1.5-1.2,4.4-2.2,6-3.4c0,0.3-0.8,3.6-0.3,3.8c7.1,2,10.8-6.2,18-8.1c-0.1,2.1,0.6,4.6,0.5,6.9
					c0.1,0.1,0.2,0.3,0.4,0.4c5.4-6.5,11.9-7.8,11,2.8c4.1-3.2,7.1-8.2,8.8-13.5c-1.5,2.9-4.7,6-6.4,8.4c-0.5-9.1-7.4-7.4-12.1-1.9
					c-0.5-1.5-1.2-3.1-1.7-4.6c-5.5,1-10,5-14.9,7.3c-0.7-0.5-5.1-3.7-5.7-4.3c7.4-23.4-15-3.1-19.9,3.1c1.4-5.6,2.3-11.8,0.9-17.5
					c-4.1,0.6-8-0.3-12,1.8c-0.2-1.6,0-3-0.1-4.6c0-0.3-1.9,0.2-2-0.1c0-2,0.8-4.3,1.3-6.1c-1.6,0.4-3.5,0.4-5.2,0.7
					c0.2-2.3,1.5-3.8,2.4-5.8L244.3,255.7z"
              />
              <path
                fill={secondary}
                d="M435.6,159.8c2.8,0.7,5.5,2,7.9,3.7c0-0.1,0,1.9,0,1.9c-0.9,0.6-3,0.6-4.1,1.1c-0.2,0.4-0.3,0.7-0.5,1.1
					c0,0.3,1.2,4.6,1.8,3.6c-3.7,4.2-3.1,4.3-3.9,9.7c-8.8,10.7,11.3,10.2,10.9,21.2c-0.3,9-22,5.1-10.3,19.6
					c-2.1,0.8-3.7,2.5-6.5,3.2c-0.2,0.2-0.3,0.3-0.5,0.5c0.7,2.3,0.5,6.5,1.2,9.2c-19.5,1-17.6,11.8-24.7,21.5
					c-0.3,0.4,2.5,5.2,0.4,7.2c-2.2,2.1-7.3-1.1-9.4,0.6c-5.9,4.8-10.5-4.9-10.9,7.1c-3.1,0-6.6,0.5-9.7,0.2
					c-0.2,0.2-0.3,0.3-0.5,0.5c-0.9,0.8,0.4,3.3-1,4.5c-3.8-0.5-7.7-0.9-11.1-2.9c2.7-0.7,5.5-0.6,8.3-0.7c4.7-4.8,1.6-3.6,8.8-5.7
					c2.2-9.2,11.7-10.3,20.2-10.3c-1.8-4.3-0.3-7.8-2.2-12.3c0.1-0.3,0.3-0.6,0.5-0.9c0.3-0.6,2.5-0.4,2.6-0.7
					c0.3-1.5-0.4-4.2,0.2-5.5c6.4-1.5,12.9-3.6,18.3-6.8c-0.1-1.4-1.4-4.2-1.8-5.6c2.3-0.3,5.1-0.2,7.4-0.7c0.7-0.8-0.7-3.9,0.1-4.5
					c0.2-0.5,3.6,0,4.1-0.2c-8.1-9.9,0.6-15.8,10.3-16c-3.5-7-11.8-10.7-13.9-19.4c0.7-0.7,2.6-0.1,3.1-0.7c0-2.4-1.1-6-0.3-8.2
					c0.6-1.1,1.9-0.1,2.6-1.1c0-2.4-0.9-3.9-1.2-6.1c5.2-0.4,4.3-3.1,5.1-4.6L435.6,159.8z"
              />
            </g>
            <path
              fill={secondary}
              d="M235.7,395.9c-5.3,28.2,0.3,61.2,8.7,88.7c-0.4-4.4-0.2-9.2,0-13.6c-0.4-1.4-0.1,0.9-0.1,1.2
				c6.8,20.7,20.2,37.9,36,51.8c0.4,0.4,0.4,0.4,0,0c-0.3-0.4-0.7-0.8-1-1.1c-17.4-26.7-23.4-54.3-31.9-84.4
				c-0.1,6.7-1.2,13.8-1.3,20c-3.4-8.8-6.2-17.3-7.7-27.4c-0.9-0.7-1,2.5-1,2.8c-2.2-8.2-2.8-16.4-3.6-25.1L235.7,395.9z"
            />
            <path
              fill={secondary}
              d="M517.3,387.4c0.7,15.6-2.1,30.6-8.3,44.4c2.4-0.9,4.7-4.4,7.2-6.1c-2.7,10.9-2.9,22.4-7.4,32.6
				c7.1-9,15.5-16.5,20.9-27.4c-1.5,12.9-2,24.5-6.4,36.9c16.7-17.1,29.9-41.4,28.8-68.5c0,0.9,0,1.8,0.1,2.6
				c-4.3,8.5-9.2,10.6-13.4,16c2.4-18.9,3.4-39.9-3.8-57c0.5,14.7-1.8,30.1-7.7,42.2c-0.2-5.2-2.7-8.9-4.1-12.6L517.3,387.4z"
            />
          </g>
        </g>
      </g>
    </>
  );
};

export default Hair_17;
